import {get as getProjection, fromLonLat, transform, transformExtent} from 'ol/proj'
import {getTopLeft, getWidth} from "ol/extent";
import TileLayer from "ol/layer/Tile";
import {WMTS} from "ol/source";
import WMTSTileGrid from "ol/tilegrid/WMTS";

export function addWMTSLayer(layer, visible)
{
    // const base_proj = layer.Service.Projection
    const base_proj = "EPSG:3857"
    const projection_3857 = getProjection("EPSG:3857")
    let projectionExtent_3857 = projection_3857.getExtent()

    const projection = getProjection(base_proj);
    const projectionExtent = projection.getExtent();
    const resolutions = new Array(20);
    const matrixIds = new Array(20);

    const size = getWidth(  projectionExtent ) / 256;

    for (let z = 0; z < resolutions.length; ++z) {
        resolutions[z] = size / Math.pow(2, z)
        matrixIds[z] = z
    }
    const wmts_layer = new TileLayer({
        extent: projectionExtent_3857,
        visible: visible,
        opacity: 1,
        zIndex: -1,
        minZoom:0,
        maxZoom:21,
        name: layer.Layer,
        source: new WMTS({
            crossOrigin: 'anonymous',
            url: layer.Url.slice(0, -1),
            layer: layer.Layer,
            matrixSet: base_proj,
            format: 'image/png',
            attributions: 'KaartViewer Next Level',
            tileGrid: new WMTSTileGrid({
                origin: getTopLeft(projectionExtent),
                resolutions: resolutions,
                matrixIds: matrixIds
            }),
            style: 'default'
        })
    })

    window.map.addLayer(wmts_layer);
}
